var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "change_mail",
    transform: "translate(106 -8111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2149",
    "data-name": "Rectangle 2149",
    width: 64,
    height: 64,
    transform: "translate(-106 8111)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cfde929122150d98f45f879fd1f3ec89",
    transform: "translate(-105.439 7016.364)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2151",
    "data-name": "Rectangle 2151",
    width: 60,
    height: 60,
    rx: 5.494,
    transform: "translate(1.439 1096.636)",
    fill: "#017f99"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Change",
    transform: "translate(13.428 1107.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24633",
    "data-name": "Path 24633",
    d: "M1,17V34.261L13.233,23.386,1,34.261a3,3,0,0,0,3,3H32.52a3,3,0,0,0,3-3L23.289,23.386,35.522,34.261V17L18.261,26.006Z",
    transform: "translate(-0.25 -3.201)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24634",
    "data-name": "Path 24634",
    d: "M33.771,10.8H28.518a.75.75,0,0,0,0,1.5h5.253a.75.75,0,0,1,.75.75v.3l-16.51,8.614L1.5,13.344v-.3a.75.75,0,0,1,.75-.75H7.5a.75.75,0,0,0,0-1.5H2.251A2.251,2.251,0,0,0,0,13.048V31.06a3.757,3.757,0,0,0,3.752,3.752H32.27a3.757,3.757,0,0,0,3.752-3.752V13.048A2.251,2.251,0,0,0,33.771,10.8ZM1.5,15.037l10.173,5.307L1.5,29.388ZM32.27,33.311H3.752a2.251,2.251,0,0,1-2.22-1.942L13.1,21.087l4.567,2.383a.75.75,0,0,0,.693,0l4.567-2.383L34.49,31.369a2.251,2.251,0,0,1-2.22,1.942Zm2.251-3.923L24.349,20.344l10.173-5.307ZM12.758,10.8a.75.75,0,0,0,.75-.75v-1.5a.75.75,0,0,1,.75-.75h7.194l-.842.842A.75.75,0,1,0,21.672,9.7L23.8,7.575a.75.75,0,0,0,0-1.061L21.672,4.391a.75.75,0,1,0-1.061,1.061l.842.842H14.259a2.251,2.251,0,0,0-2.251,2.251v1.5A.75.75,0,0,0,12.758,10.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24635",
    "data-name": "Path 24635",
    d: "M28.008,15.251v-1.5a.75.75,0,1,0-1.5,0v1.5a.75.75,0,0,1-.75.75H18.562l.842-.842A.75.75,0,1,0,18.343,14.1L16.22,16.222a.75.75,0,0,0,0,1.061l2.123,2.123A.75.75,0,1,0,19.4,18.345l-.842-.842h7.194A2.251,2.251,0,0,0,28.008,15.251Z",
    transform: "translate(-3.993 -2.203)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeMail);
export default __webpack_public_path__ + "static/media/change_mail.22062f3df8a5b00329ddc814c4154e6d.svg";
export { ForwardRef as ReactComponent };